import styled from "styled-components";

export const Chip = styled.div`
  text-align: center;
  padding: 0.2rem 0.5rem;
  background: #ffffff;
  border: 1px solid #000000;
  box-sizing: border-box;
  border-radius: 20px;
  width: max-content;
  min-width: 120px;
`;
